function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Input } from "semantic-ui-react";
import { isEmpty } from "lodash-es";
import CurrencyInput from "../currencyinput/CurrencyInput";
import { Label } from "../../components/label/Label";
import { useAutoId } from "../../helpers/hooks";
const TextFieldGroup = /*#__PURE__*/React.forwardRef(({
  field,
  value,
  label,
  onChange,
  placeholder,
  disabled,
  onFocus,
  onBlur,
  className,
  error,
  type,
  size,
  inputProps,
  style,
  maxLength,
  id,
  currency,
  fluid,
  children
}, ref) => {
  const InputComponent = currency ? CurrencyInput : Input;
  const inputId = useAutoId(inputProps?.id, "tui-text-field-group");
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(`form-group ${className}`, {
      "has-error": error
    }),
    style: style,
    id: id
  }, label && /*#__PURE__*/React.createElement(Label, {
    htmlFor: inputId
  }, label), /*#__PURE__*/React.createElement(InputComponent, _extends({
    ref: ref,
    fluid: fluid,
    children: children,
    className: className,
    onFocus: onFocus,
    onChange: onChange,
    onBlur: onBlur,
    name: field,
    placeholder: placeholder,
    disabled: disabled,
    value: value,
    type: type,
    size: size,
    error: !isEmpty(error),
    maxLength: maxLength,
    onKeyDown: e => {
      if (type === "number") {
        if (!(/^[0-9.]*$/.test(e.key) || e.keyCode >= 3 && e.keyCode <= 47) && !e.ctrlKey && !e.altKey) {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    }
  }, inputProps, {
    id: inputId
  })), error ? /*#__PURE__*/React.createElement("div", {
    className: "tui-invalid-feedback",
    children: error
  }) : "");
});
TextFieldGroup.displayName = "TextFieldGroup";
export const TextFieldGroupDefaultProps = {
  disabled: false,
  style: {},
  onFocus: undefined,
  onBlur: undefined,
  id: undefined,
  className: "",
  type: undefined,
  size: undefined,
  error: undefined,
  field: undefined,
  value: undefined,
  label: undefined,
  onChange: undefined,
  placeholder: undefined,
  inputProps: {},
  maxLength: undefined,
  currency: false,
  fluid: true,
  children: undefined
};
export const TextFieldGroupPropTypes = {
  field: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  inputProps: PropTypes.object,
  disabled: PropTypes.bool,
  style: PropTypes.object,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  maxLength: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.string,
  error: PropTypes.node,
  currency: PropTypes.bool,
  fluid: PropTypes.bool,
  children: PropTypes.node
};
TextFieldGroup.defaultProps = TextFieldGroupDefaultProps;
TextFieldGroup.propTypes = TextFieldGroupPropTypes;
export default TextFieldGroup;
//# sourceMappingURL=TextFieldGroup.js.map